export default __webpack_public_path__ + "static/media/CV_JhonathanAntonio.db293b99.pdf";